import React, { useState } from "react";
import { ObjectiveForm } from "./ObjectiveForm";
import { ObjectiveRow } from "./ObjectiveRow";
import { CategoryHeader } from "./CategoryHeader";

export function CategorySection({
  category,
  expanded,
  editingObjective,
  categoryObjectives,
  objectiveErrors,
  getCategoryIcon,
  getCategoryColor,
  onToggleCategory,
  onEditCategory,
  onDeleteCategory,
  onAddObjective,
  onObjectiveFieldChange,
  onStartEditObjective,
  onSaveEditObjective,
  onCancelEditObjective,
  onRemoveObjective,
  onEditObjectiveFieldChange,
  calculateObjectivesTotal
}) {
  const objectivesTotal = calculateObjectivesTotal(category.objectives);
  const remainingPercentage = (parseFloat(category.totalPercentage) || 0) - objectivesTotal;

  return (
    <React.Fragment key={category.id}>
      <CategoryHeader
        category={category}
        expanded={expanded}
        getCategoryIcon={getCategoryIcon}
        getCategoryColor={getCategoryColor}
        onToggle={onToggleCategory}
        onEdit={onEditCategory}
        onDelete={onDeleteCategory}
        calculateObjectivesTotal={calculateObjectivesTotal}
      />

      {expanded && (
        <React.Fragment>
          <tr className="bg-gray-50 hover:bg-gray-100 transition-colors">
            <td className="px-6 py-4" colSpan="4">
              <ObjectiveForm
                categoryId={category.id}
                formData={categoryObjectives[category.id]}
                remainingPercentage={remainingPercentage}
                errors={objectiveErrors}
                onFieldChange={onObjectiveFieldChange}
                onAdd={() => onAddObjective(category)}
                disabled={remainingPercentage <= 0}
              />
            </td>
          </tr>

          {category.objectives?.map((objective) => {
            const isEditing = editingObjective && editingObjective.id === objective.id;

            return (
              <ObjectiveRow
                key={objective.id}
                objective={objective}
                category={category}
                isEditing={isEditing}
                editingObjective={editingObjective}
                errors={objectiveErrors}
                remainingPercentage={remainingPercentage}
                onStartEdit={(obj) => onStartEditObjective(category, obj)}
                onSaveEdit={onSaveEditObjective}
                onCancelEdit={onCancelEditObjective}
                onRemove={(objId) => onRemoveObjective(category.id, objId)}
                onEditFieldChange={onEditObjectiveFieldChange}
              />
            );
          })}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}